<template>


<div class="full-reset">
			<div class="container">
				<div class="row">
					<div class="col-xs-12 col-sm-4">
						<span class="full-reset titles">Recursos educativos</span>
						<ul class="list-unstyled full-reset">
							<li><a href="https://scratch.mit.edu/" class="open-link-newTab"><i class="fa fa-search"></i>&nbsp;scratch</a></li>
							<li><a href="https://lazos.neuquen.edu.ar/" class="open-link-newTab"><i class="fa fa-graduation-cap"></i>&nbsp;Plataforma Lazos</a></li>
						</ul>
					</div>
					<div class="col-xs-12 col-sm-4">
						<span class="full-reset titles">Enlaces importantes</span>
						<ul class="list-unstyled full-reset">
							<li><a href="https://www.uncoma.edu.ar/" class="open-link-newTab"><i class="fa fa-university"></i>&nbsp;Universidad del Comahue</a></li>
							
							<li><a href="https://www.argentina.gob.ar/jefatura/instituto-nacional-de-juventud"><i class="fa fa-globe"></i>&nbsp; JOVENES </a></li>
							<li><a href="https://utn.edu.ar/es/" class="open-link-newTab"><i class="fa fa-flask"></i>&nbsp;UTN</a></li>
							
						</ul>
					</div>
					<div class="col-xs-12 col-sm-4">
						<span class="full-reset titles">Archivos</span>
						<ul class="list-unstyled full-reset">
							<li><a href="https://drive.google.com/file/d/1uLcZOBEOoCqvmq_9mxhS1GSPaXF211nV/view?usp=sharing"><i class="fa fa-star-o"></i>&nbsp; Resolución 151 </a></li>
							
							<li><a href="Programas.html"><i class="fa fa-download"></i>&nbsp; Descargar programas</a></li>
						</ul>
					</div>
				</div>
			</div>
			<i class="fa fa-times-circle btm-mega-menu close-mega-menu fa-2x"></i>
			
		</div>




</template>

<script>




export default {
  name: "Mas",
  components: {
   
  }
};

</script>
		
		
		
		
		






		
		


// WEBPACK FOOTER //
// src/components/Mas.vue